import { create } from 'zustand';
import { InviteStore } from './typings';

const useInviteStore = create<InviteStore>((set) => ({
  emails: [],
  users: [],
  role: undefined,

  setRole: (role) => set({ role }),
  setEmails: (emails) => set({ emails }),
  setUsers: (users) => set({ users }),
}));

export default useInviteStore;
